import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Container = styled.div`
    min-height: 52px;
    padding: 16px;
    background-color: var(--gray800);
    border-radius: 4px;
    box-shadow: var(--shadow-3);
`;

const Notification = ({ children }) => {
    return <Container>{children}</Container>;
};

Notification.propTypes = {
    children: PropTypes.node,
};

export default Notification;
